// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPasswordForm_container__1Q3Hy","column":"ResetPasswordForm_column__3LYDn","icon":"ResetPasswordForm_icon__Zb-HE"};